import { render, staticRenderFns } from "./Headlines.vue?vue&type=template&id=42183ab1&scoped=true"
import script from "./Headlines.vue?vue&type=script&lang=ts"
export * from "./Headlines.vue?vue&type=script&lang=ts"
import style0 from "./Headlines.vue?vue&type=style&index=0&id=42183ab1&prod&scoped=true&lang=scss"
import style1 from "./Headlines.vue?vue&type=style&index=1&id=42183ab1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42183ab1",
  null
  
)

export default component.exports